import { render } from "./ObjectsView.vue?vue&type=template&id=405ca51d&scoped=true"
import script from "./ObjectsView.vue?vue&type=script&lang=js"
export * from "./ObjectsView.vue?vue&type=script&lang=js"

import "./ObjectsView.vue?vue&type=style&index=0&id=405ca51d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405ca51d"]])

export default __exports__